export default __webpack_public_path__ + "static/media/digital.29c581c3.png";